/**
 * Task KK: Platform admin → 店家 (shop list, tiles, shop detail, actions, platform alerts).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["kk.nav","Shops","店家"],
  ["kk.navOps","Operations","运营监控"],
  ["kk.title","Shops","店家"],
  ["kk.sub","Every shop on Senvia POS: owner, plan, trial and billing.","Senvia POS 上的所有店家：店主、方案、试用和账单。"],
  ["kk.tile.total","Shops","店家总数"],
  ["kk.tile.trial","In trial","试用中"],
  ["kk.tile.ending","Trial ends ≤ 7 days","7 天内试用到期"],
  ["kk.tile.paying","Paying","已付费"],
  ["kk.tile.overdue","Overdue","逾期未付"],
  ["kk.tile.canceled","Cancelled this month","本月取消"],
  ["kk.tile.mrr","MRR (USD)","月经常性收入 MRR（USD）"],
  ["kk.tile.signups","New sign-ups","新注册"],
  ["kk.tile.signupsVal","{w} this week · {m} this month","本周 {w} · 本月 {m}"],
  ["kk.tile.conv","Trial → paid","试用转付费"],
  ["kk.tile.convHint","{a} of {b} shops whose trial is over","试用已结束的 {b} 家中 {a} 家付费"],
  ["kk.search","Search name, e-mail or phone","搜索店名、邮箱或电话"],
  ["kk.f.status","Status","状态"],
  ["kk.f.plan","Plan","方案"],
  ["kk.f.country","Country","国家"],
  ["kk.f.all","All","全部"],
  ["kk.f.ending","Trial ends in 7 days","7 天内试用到期"],
  ["kk.f.from","Created from","注册日期从"],
  ["kk.f.to","to","至"],
  ["kk.f.sort","Sort","排序"],
  ["kk.f.tag","Tag","标签"],
  ["kk.f.clear","Clear filters","清除筛选"],
  ["kk.sort.created_desc","Newest first","最新注册"],
  ["kk.sort.created_asc","Oldest first","最早注册"],
  ["kk.sort.name","Name","店名"],
  ["kk.sort.trial_end","Trial ends soonest","试用最快到期"],
  ["kk.sort.mrr_desc","Highest MRR","MRR 最高"],
  ["kk.sort.last_active","Recently active","最近活跃"],
  ["kk.csv","Export CSV","导出 CSV"],
  ["kk.settings","Platform alerts","平台通知"],
  ["kk.count","{n} shops","共 {n} 家"],
  ["kk.none","No shops match these filters.","没有符合条件的店家。"],
  ["kk.col.shop","Shop","店家"],
  ["kk.col.owner","Owner","店主"],
  ["kk.col.plan","Plan","方案"],
  ["kk.col.status","Status","状态"],
  ["kk.col.trial","Trial ends","试用到期"],
  ["kk.col.next","Next billing","下次扣款"],
  ["kk.col.mrr","MRR","MRR"],
  ["kk.col.size","Branches · staff · customers","分店 · 员工 · 顾客"],
  ["kk.col.active","Last active","最近活跃"],
  ["kk.col.created","Created","注册日期"],
  ["kk.col.domain","Domain","域名"],
  ["kk.st.trial","In trial","试用中"],
  ["kk.st.trial_expired","Trial ended","试用已结束"],
  ["kk.st.paid","Paid","已付费"],
  ["kk.st.comp","Free (comp)","免费赠送"],
  ["kk.st.overdue","Overdue","逾期未付"],
  ["kk.st.canceled","Cancelled","已取消"],
  ["kk.st.suspended","Suspended","已停用"],
  ["kk.st.none","No plan","无方案"],
  ["kk.daysLeft","{n} days left","还剩 {n} 天"],
  ["kk.dayLeft","Ends today","今天到期"],
  ["kk.expired","Ended {n} days ago","已过期 {n} 天"],
  ["kk.cancelsAtEnd","Cancels at period end","本期结束后取消"],
  ["kk.never","Never","从未"],
  ["kk.prev","Previous","上一页"],
  ["kk.next","Next","下一页"],
  ["kk.page","Page {p} of {n}","第 {p} / {n} 页"],
  ["kk.open","Open","查看"],
  ["kk.back","All shops","全部店家"],
  ["kk.d.profile","Shop profile","店家资料"],
  ["kk.d.owner","Owner contact","店主联系方式"],
  ["kk.d.plan","Plan & add-ons","方案与附加功能"],
  ["kk.d.trial","Trial","试用"],
  ["kk.d.trialStart","Started","开始"],
  ["kk.d.trialEnd","Ends","结束"],
  ["kk.d.invoices","Invoices & payments","发票与付款"],
  ["kk.d.noInvoices","No Senvia invoices yet.","还没有 Senvia 发票。"],
  ["kk.d.usage","Usage this month","本月使用情况"],
  ["kk.d.orders","Sales","销售单"],
  ["kk.d.staff","Active staff","在职员工"],
  ["kk.d.ai","AI messages","AI 消息"],
  ["kk.d.msgs","Messages sent","已发送消息"],
  ["kk.d.domains","Domains","域名"],
  ["kk.d.noDomains","No custom domain.","没有自定义域名。"],
  ["kk.d.notes","Platform notes","平台内部备注"],
  ["kk.d.notesHint","Only the Senvia team sees these notes and tags.","备注和标签只有 Senvia 团队看得到。"],
  ["kk.d.addNote","Add note","添加备注"],
  ["kk.d.notePh","e.g. Called the owner, wants a demo of the website","例如：已致电店主，想看网站功能演示"],
  ["kk.d.tags","Tags","标签"],
  ["kk.d.tagsPh","VIP, migrating, …","VIP、搬家中、…"],
  ["kk.d.saveTags","Save tags","保存标签"],
  ["kk.d.audit","Platform actions","平台操作记录"],
  ["kk.d.history","Subscription history","订阅记录"],
  ["kk.d.addons","Add-ons","附加功能"],
  ["kk.d.noAddons","No add-ons.","没有附加功能。"],
  ["kk.d.comp","comp","赠送"],
  ["kk.d.included","in plan","方案已含"],
  ["kk.d.actions","Actions","操作"],
  ["kk.d.locale","Language","语言"],
  ["kk.d.timezone","Time zone","时区"],
  ["kk.d.currency","Currency","货币"],
  ["kk.d.created","Signed up","注册时间"],
  ["kk.d.lastLogin","Last login","最近登录"],
  ["kk.d.lastActive","Last active","最近活跃"],
  ["kk.d.size","{b} branches · {s} staff · {c} customers","{b} 家分店 · {s} 位员工 · {c} 位顾客"],
  ["kk.d.nextBilling","Next billing: {date} · {amount}","下次扣款：{date} · {amount}"],
  ["kk.d.mrr","MRR {amount}","MRR {amount}"],
  ["kk.d.stripe","Billed by Stripe","由 Stripe 扣款"],
  ["kk.d.manual","Managed by the platform","由平台管理"],
  ["kk.a.extend","Extend trial","延长试用"],
  ["kk.a.extendBody","New trial end: {date}. The shop keeps full access until then.","新的试用结束日期：{date}。在此之前店家可以正常使用全部功能。"],
  ["kk.a.custom","Custom date","自定日期"],
  ["kk.a.plus","+{n} days","+{n} 天"],
  ["kk.a.plan","Change plan","更换方案"],
  ["kk.a.comp","Free of charge (comp) — no trial end, no payment","免费赠送 — 不设试用期、不收费"],
  ["kk.a.planBody","Move {shop} to {plan}{comp}?","把 {shop} 改为 {plan}{comp}？"],
  ["kk.a.compSuffix"," (free)","（免费）"],
  ["kk.a.grant","Give add-on free","免费开通附加功能"],
  ["kk.a.revoke","Remove","移除"],
  ["kk.a.grantBody","Give {addon} to {shop} free of charge?","免费为 {shop} 开通 {addon}？"],
  ["kk.a.revokeBody","Remove the free {addon} from {shop}?","移除 {shop} 的免费 {addon}？"],
  ["kk.a.suspend","Suspend shop","停用店家"],
  ["kk.a.suspendBody","Nobody at {shop} can use the shop until you reactivate it. Their data is kept.","重新启用之前，{shop} 的所有人都无法使用该店。资料会保留。"],
  ["kk.a.reactivate","Reactivate","重新启用"],
  ["kk.a.reactivateBody","Let {shop} use Senvia POS again?","让 {shop} 恢复使用 Senvia POS？"],
  ["kk.a.reason","Reason (kept in the audit log)","原因（记录在操作日志中）"],
  ["kk.a.email","E-mail the owner","发邮件给店主"],
  ["kk.a.template","Template","模板"],
  ["kk.a.tpl.trial_ending","Trial ending soon","试用即将到期"],
  ["kk.a.tpl.trial_expired","Trial has ended","试用已结束"],
  ["kk.a.tpl.payment_reminder","Payment problem","扣款问题"],
  ["kk.a.tpl.check_in","Check-in","问候回访"],
  ["kk.a.tpl.custom","Own message","自己写"],
  ["kk.a.lang","Language","语言"],
  ["kk.a.subject","Subject","主题"],
  ["kk.a.body","Message","内容"],
  ["kk.a.preview","Preview","预览"],
  ["kk.a.send","Send e-mail","发送邮件"],
  ["kk.a.sendBody","Send this e-mail to {to}?","确定发送这封邮件给 {to}？"],
  ["kk.a.sent","E-mail sent to {to}","已发送邮件给 {to}"],
  ["kk.a.done","Saved","已保存"],
  ["kk.a.confirm","Confirm","确认"],
  ["kk.a.stripeNote","This shop pays by card: plan and trial changes are made in Stripe / by the owner.","此店家以信用卡付费：方案和试用请在 Stripe 或由店主自行更改。"],
  ["kk.a.viewAs","View customers (support)","查看顾客（客服）"],
  ["kk.a.viewAsNote","Read-only, needs a reason, 30 minutes, written to the shop's own audit log.","只读、需填写原因、30 分钟有效，并记录在店家自己的操作日志里。"],
  ["kk.n.title","Platform alerts","平台通知"],
  ["kk.n.intro","E-mails to the Senvia team about shops. Without an address nothing is sent.","有关店家的邮件通知，发给 Senvia 团队。未填写邮箱时不会发送。"],
  ["kk.n.emails","Send alerts to","通知邮箱"],
  ["kk.n.emailsHint","One or more e-mail addresses, separated by commas.","一个或多个邮箱，用逗号分隔。"],
  ["kk.n.useMine","Use {email}","使用 {email}"],
  ["kk.n.ev.signup","New sign-up","新店家注册"],
  ["kk.n.ev.trial_ending","Trial ends in 3 days","试用 3 天后到期"],
  ["kk.n.ev.trial_expired","Trial ended without payment","试用结束仍未付费"],
  ["kk.n.ev.payment_failed","Payment failed","扣款失败"],
  ["kk.n.ev.cancellation","Cancellation","取消订阅"],
  ["kk.n.ev.lead","New support / sales lead","新的客服 / 销售线索"],
  ["kk.n.save","Save","保存"],
  ["kk.n.test","Send a test","发送测试邮件"],
  ["kk.n.testSent","Test sent to {n} address(es)","已发送测试邮件到 {n} 个邮箱"],
  ["kk.n.off","Alerts are off: add an address.","通知未开启：请填写邮箱。"],
] as const;

export type KkKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<KkKey, string>;

export const taskKK = { en: col(1), zh: col(2), ms: col(1) };
